// Focus Set model constants

// Set sizes
export const FOCUS_SET_SIZE = 8;
export const MASTERY_THRESHOLD = 0.9; // 90% of Focus set must have last_result = correct

// p_correct calculation
export const NEW_ITEM_P_CORRECT = 0.35;
export const DECAY_LAMBDA = 0.1; // Decay rate for exponential weighting (per hour)

// Session composition - Normal mode (Old set exists)
export const NORMAL_SESSION_SIZE = 6;
export const NORMAL_EASY_COUNT = 1;
export const NORMAL_HARD_COUNT = 4;
export const NORMAL_RANDOM_COUNT = 1;

// Session composition - Cold start (Old is empty)
export const COLD_START_SESSION_SIZE = 6;
export const COLD_START_EASY_COUNT = 1;
export const COLD_START_HARD_COUNT = 5;

// p_correct thresholds
export const EASY_THRESHOLD = 0.8;     // p > 80% is easy
export const HARD_THRESHOLD_1 = 0.5;   // p < 50% is hard (first choice)
export const HARD_THRESHOLD_2 = 0.7;   // p < 70% is hard (fallback)

// Retry settings
export const RETRY_DELAY_PROBLEMS = 3; // Wait 3 other questions before retry
